import {
    EDIT_USER, DELETE_USER, CREATE_USER, CREATE_USER_SUCCESS, UPDATE_USER_SUCCESS,
    UPDATE_USER, DELETE_USER_SUCCESS, FETCH_ALL_USER, FETCH_ALL_USER_SUCCESS,SET_USER,SET_ROLE,
    VERIFY_EMAIL,VERIFY_EMAIL_SUCCESS, SET_PASSWORD, SET_PASSWORD_SUCCESS, FORGOT_PASSWORD
  } from 'constants/users.constants'
import { startLoader } from 'actions/general.action';

export const setUser = (key, value) => {
    return {
      type : SET_USER,
      key: key,
      value: value
    }
}

export const setRoles = (key, value) => {
  return {
    type: SET_ROLE,
    key:key,
    value:value
  }
}

export const fetchUsers = (page) => {
    return dispatch => {
      dispatch({
        type: FETCH_ALL_USER,
        payload: page
      })
      dispatch(startLoader())
    }
  }
  
  export const fetchUsersSuccess = (data) => {
    return {
      type: FETCH_ALL_USER_SUCCESS,
      payload: data
    };
  };
  
  export const deleteUser = (id) => {
    return {
      type: DELETE_USER,
      payload: id
    };
  };
  
  export const editUser = (id) => {
    return {
      type: EDIT_USER,
      payload: id
    };
  };
  
  export const createUser = (payload) => {
    console.log(payload)
    return {
      type: CREATE_USER,
      payload: payload
    };
  };
  
  export const createUserSuccess = (payload) => {
    return {
      type: CREATE_USER_SUCCESS,
      payload: payload
    };
  };
  
  export const updateUserSuccess = (data) => {
    return {
      type: UPDATE_USER_SUCCESS,
      payload: data
    };
  };
  
  export const deleteUserSuccess = (data) => {
    return {
      type: DELETE_USER_SUCCESS,
      payload: data
    };
  };
  
  export const updateUser = (payload) => {
    return {
      type: UPDATE_USER,
      payload: payload
    };
  }; 

  export const verifyEmail = (token) => {
    return {
        type: VERIFY_EMAIL,
        payload: token
    };
  };
  
  export const verifyEmailSuccess = () => {
    return {
        type: VERIFY_EMAIL_SUCCESS
    }
  };

  export const setUserPassword = (payload) => {
    return {
        type: SET_PASSWORD,
        payload: payload
    };
  };

  export const setUserPasswordSuccess = () => {
    return {
        type: SET_PASSWORD_SUCCESS,
    };
  };

  export const forgotUserPassword = (email) => {
    return {
        type: FORGOT_PASSWORD,
        payload: email
    };
  };